import React from 'react';
import PlaygroundPage from './PlaygroundPage';

/**
 * Public Playground entry — renders the full multi-model comparison
 * workspace. Used by both the task-page overlay (with `onExit` to close the
 * overlay via the breadcrumb) and the standalone `/playground` route.
 */
export const Playground = ({ onExit }) => <PlaygroundPage onExit={onExit} />;

export default Playground;
